import { FC, SVGProps } from 'react'

export const ArrowUp: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.4794 10.7621C5.18123 10.4746 5.1726 9.99979 5.46012 9.70162L11.4601 3.4794C11.6015 3.33281 11.7964 3.25 12 3.25C12.2036 3.25 12.3985 3.33281 12.5399 3.4794L18.5399 9.70162C18.8274 9.99979 18.8188 10.4746 18.5206 10.7621C18.2224 11.0496 17.7476 11.041 17.4601 10.7428L12.75 5.85826L12.75 20C12.75 20.4142 12.4142 20.75 12 20.75C11.5858 20.75 11.25 20.4142 11.25 20L11.25 5.85826L6.53988 10.7428C6.25236 11.041 5.77757 11.0496 5.4794 10.7621Z"
			fill="currentColor"
		/>
	</svg>
)
